import { render } from "./FooterSite.vue?vue&type=template&id=40a648f0"
import script from "./FooterSite.vue?vue&type=script&lang=js"
export * from "./FooterSite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__